import React from 'react'
import { SvgIcon, SvgIconProps } from '@mui/material'

/**
 * Hairline sparkle for the AI surface. Strokes use non-scaling-stroke so the
 * outline stays 1px at every call site (40px sidebar rail down to the 16px
 * chat avatar) instead of fading out as the icon shrinks.
 */
const AiSparkIconSvg = (
    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M21.5 17 Q24.65 24.35 32 27.5 Q24.65 30.65 21.5 38 Q18.35 30.65 11 27.5 Q18.35 24.35 21.5 17 Z"
            stroke="currentColor"
            strokeWidth={1}
            strokeLinejoin="round"
            vectorEffect="non-scaling-stroke"
        />
        <path
            d="M32.5 10 Q34.3 14.2 38.5 16 Q34.3 17.8 32.5 22 Q30.7 17.8 26.5 16 Q30.7 14.2 32.5 10 Z"
            stroke="currentColor"
            strokeWidth={1}
            strokeLinejoin="round"
            vectorEffect="non-scaling-stroke"
        />
    </svg>
)

const AiSparkIcon: React.FC<SvgIconProps> = ({ style, ...props }) => (
    <SvgIcon {...props} style={{ fontSize: '40px', ...style }}>
        {AiSparkIconSvg}
    </SvgIcon>
)

export default AiSparkIcon
